import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, renderList as _renderList, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "map-page" };
const _hoisted_2 = { class: "map-header-section" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "map-header-content" };
const _hoisted_5 = { class: "map-filters" };
const _hoisted_6 = { class: "filter-group" };
const _hoisted_7 = { class: "filter-group" };
const _hoisted_8 = { class: "filter-group" };
const _hoisted_9 = { class: "filter-group search-filter-group" };
const _hoisted_10 = { class: "map-search-control" };
const _hoisted_11 = { class: "map-main-section" };
const _hoisted_12 = { class: "map-experience" };
const _hoisted_13 = { class: "results-sidebar" };
const _hoisted_14 = { class: "sidebar-inner" };
const _hoisted_15 = { class: "results-meta" };
const _hoisted_16 = { class: "results-count" };
const _hoisted_17 = {
    key: 0,
    class: "results-loading"
};
const _hoisted_18 = {
    key: 1,
    class: "results-list"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["src", "alt"];
const _hoisted_21 = {
    key: 1,
    class: "media-fallback"
};
const _hoisted_22 = {
    key: 2,
    class: "badge badge-destination"
};
const _hoisted_23 = {
    key: 3,
    class: "badge badge-city"
};
const _hoisted_24 = {
    key: 4,
    class: "badge badge-dept"
};
const _hoisted_25 = { class: "card-body" };
const _hoisted_26 = { class: "card-title" };
const _hoisted_27 = {
    key: 0,
    class: "card-sub"
};
const _hoisted_28 = { class: "card-desc" };
const _hoisted_29 = { class: "card-actions" };
const _hoisted_30 = ["onClick"];
const _hoisted_31 = { class: "map-area" };
const _hoisted_32 = {
    class: "map-wrapper",
    ref: "mapWrapperRef"
};
const _hoisted_33 = {
    key: 0,
    class: "place-info-panel"
};
const _hoisted_34 = { class: "place-info-content" };
const _hoisted_35 = { class: "place-info-header" };
const _hoisted_36 = { class: "place-image" };
const _hoisted_37 = ["src", "alt"];
const _hoisted_38 = ["src", "alt"];
const _hoisted_39 = { class: "place-details" };
const _hoisted_40 = {
    key: 1,
    class: "place-name"
};
const _hoisted_41 = { class: "place-location" };
const _hoisted_42 = {
    key: 2,
    class: "place-rating"
};
const _hoisted_43 = { class: "place-description" };
const _hoisted_44 = {
    key: 0,
    class: "share-toast-panel",
    role: "status",
    "aria-live": "polite"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_InteractiveMap = _resolveComponent("InteractiveMap");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _cache[15] || (_cache[15] = _createElementVNode("h1", { class: "map-title" }, "Mapa Interactivo de Bolivia", -1)),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _cache[7] || (_cache[7] = _createElementVNode("label", { class: "filter-label" }, "Categoría:", -1)),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.selectedCategory) = $event)),
                                class: "filter-select"
                            }, [...(_cache[6] || (_cache[6] = [
                                    _createStaticVNode("<option value=\"\" data-v-31e9eaba>Todas las categorias</option><option value=\"Internacional\" data-v-31e9eaba>Internacionales</option><option value=\"Nacional\" data-v-31e9eaba>Nacionales</option><option value=\"Regional\" data-v-31e9eaba>Regionales</option><option value=\"Local\" data-v-31e9eaba>Locales</option>", 5)
                                ]))], 512), [
                                [_vModelSelect, $setup.selectedCategory]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "filter-label" }, "Destinos:", -1)),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.selectedDestination) = $event)),
                                class: "filter-select destination-select"
                            }, [...(_cache[8] || (_cache[8] = [
                                    _createElementVNode("option", { value: "" }, "Todos", -1),
                                    _createElementVNode("option", { value: "destination" }, "Solo destinos", -1)
                                ]))], 512), [
                                [_vModelSelect, $setup.selectedDestination]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "filter-label" }, "Departamento:", -1)),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($setup.selectedDepartment) = $event)),
                                class: "filter-select"
                            }, [...(_cache[10] || (_cache[10] = [
                                    _createStaticVNode("<option value=\"\" data-v-31e9eaba>Todos los departamentos</option><option value=\"la-paz\" data-v-31e9eaba>La Paz</option><option value=\"cochabamba\" data-v-31e9eaba>Cochabamba</option><option value=\"santa-cruz\" data-v-31e9eaba>Santa Cruz</option><option value=\"oruro\" data-v-31e9eaba>Oruro</option><option value=\"potosi\" data-v-31e9eaba>Potosí</option><option value=\"tarija\" data-v-31e9eaba>Tarija</option><option value=\"beni\" data-v-31e9eaba>Beni</option><option value=\"pando\" data-v-31e9eaba>Pando</option>", 9)
                                ]))], 512), [
                                [_vModelSelect, $setup.selectedDepartment]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _cache[14] || (_cache[14] = _createElementVNode("label", { class: "filter-label" }, "Buscar lugar:", -1)),
                            _createElementVNode("div", _hoisted_10, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($setup.searchDraft) = $event)),
                                    type: "text",
                                    class: "filter-select map-search-input",
                                    placeholder: "Nombre o departamento"
                                }, null, 512), [
                                    [_vModelText, $setup.searchDraft]
                                ]),
                                _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fas fa-search map-search-icon" }, null, -1)),
                                ($setup.searchDraft)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "map-search-clear",
                                        type: "button",
                                        "aria-label": "Limpiar búsqueda",
                                        onClick: _cache[4] || (_cache[4] =
                                            //@ts-ignore
                                            (...args) => ($setup.clearSearch && $setup.clearSearch(...args)))
                                    }, [...(_cache[12] || (_cache[12] = [
                                            _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                        ]))]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ])
            ])
        ]),
        _cache[23] || (_cache[23] = _createElementVNode("section", null, null, -1)),
        _createElementVNode("section", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
                _createElementVNode("aside", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("span", _hoisted_16, [
                                ($setup.loading)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode("Cargando lugares...")
                                    ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString($setup.displayedPlaces.length) + " resultados", 1)
                                    ], 64))
                            ])
                        ]),
                        ($setup.loading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[16] || (_cache[16] = [
                                    _createElementVNode("div", { class: "spinner" }, null, -1),
                                    _createElementVNode("p", null, "Cargando ubicaciones...", -1)
                                ]))]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayedPlaces, (place) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: `${place.tipo}-${place.id}`,
                                        class: "result-card",
                                        onClick: ($event) => ($setup.selectPlace(place))
                                    }, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["card-media", { placeholder: !(place.imagenes && place.imagenes[0]) }])
                                        }, [
                                            (place.imagenes && place.imagenes[0])
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: place.imagenes[0],
                                                    alt: place.nombre
                                                }, null, 8, _hoisted_20))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[17] || (_cache[17] = [
                                                        _createElementVNode("i", { class: "fas fa-map-marked-alt" }, null, -1)
                                                    ]))])),
                                            (place.locType === 'destination')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Destino"))
                                                : (place.tipo === 'city')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Ciudad"))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_24, "Lugar"))
                                        ], 2),
                                        _createElementVNode("div", _hoisted_25, [
                                            _createElementVNode("h4", _hoisted_26, _toDisplayString(place.nombre), 1),
                                            (place.tipo === 'place')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                    _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fas fa-map-marker-alt" }, null, -1)),
                                                    _createElementVNode("span", null, _toDisplayString(place.region), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("p", _hoisted_28, _toDisplayString(place.descripcion), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_29, [
                                            _createElementVNode("button", {
                                                class: "btn btn-sm btn-outline-primary",
                                                onClick: _withModifiers(($event) => ($setup.viewOnMap(place)), ["stop"])
                                            }, " Ver en mapa ", 8, _hoisted_30),
                                            ($setup.getDetailTo(place))
                                                ? (_openBlock(), _createBlock(_component_router_link, {
                                                    key: 0,
                                                    to: $setup.getDetailTo(place),
                                                    class: "btn btn-sm btn-primary"
                                                }, {
                                                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                                            _createTextVNode(" Detalles ", -1)
                                                        ]))]),
                                                    _: 1
                                                }, 8, ["to"]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 8, _hoisted_19));
                                }), 128))
                            ]))
                    ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_InteractiveMap, {
                            lugares: $setup.displayedPlaces,
                            center: [-16.5, -68.15],
                            zoom: 6,
                            lugarActivo: $setup.selectedPlace || undefined,
                            height: "600px",
                            onPlaceClicked: $setup.handlePlaceClick
                        }, null, 8, ["lugares", "lugarActivo", "onPlaceClicked"])
                    ], 512)
                ])
            ])
        ]),
        ($setup.selectedPlace)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("button", {
                        class: "close-button",
                        onClick: _cache[5] || (_cache[5] =
                            //@ts-ignore
                            (...args) => ($setup.closePlaceInfo && $setup.closePlaceInfo(...args)))
                    }, [...(_cache[20] || (_cache[20] = [
                            _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                        ]))]),
                    _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                            ($setup.getDetailTo($setup.selectedPlace))
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: $setup.getDetailTo($setup.selectedPlace),
                                    style: { "display": "block", "height": "100%" }
                                }, {
                                    default: _withCtx(() => [
                                        ($setup.selectedPlace.imagenes?.[0])
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: $setup.selectedPlace.imagenes?.[0],
                                                alt: $setup.selectedPlace.nombre
                                            }, null, 8, _hoisted_37))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }, 8, ["to"]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    ($setup.selectedPlace.imagenes?.[0])
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: $setup.selectedPlace.imagenes?.[0],
                                            alt: $setup.selectedPlace.nombre
                                        }, null, 8, _hoisted_38))
                                        : _createCommentVNode("", true)
                                ], 64)),
                            _createElementVNode("div", {
                                class: "place-badge",
                                style: _normalizeStyle({ backgroundColor: $setup.getCategoryColor($setup.selectedPlace.categoria) })
                            }, _toDisplayString($setup.selectedPlace.categoria || 'Turístico'), 5)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                            ($setup.getDetailTo($setup.selectedPlace))
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: $setup.getDetailTo($setup.selectedPlace),
                                    class: "place-name",
                                    style: { "text-decoration": "none" }
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.selectedPlace.nombre), 1)
                                    ]),
                                    _: 1
                                }, 8, ["to"]))
                                : (_openBlock(), _createElementBlock("h3", _hoisted_40, _toDisplayString($setup.selectedPlace.nombre), 1)),
                            _createElementVNode("p", _hoisted_41, [
                                _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fas fa-map-marker-alt" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString($setup.selectedPlace.region), 1)
                            ]),
                            ($setup.selectedPlace.rating)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fas fa-star" }, null, -1)),
                                    _createElementVNode("span", null, _toDisplayString($setup.selectedPlace.rating), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("p", null, _toDisplayString($setup.selectedPlace.descripcion), 1)
                    ]),
                    _createVNode(_Transition, { name: "fade" }, {
                        default: _withCtx(() => [
                            ($setup.shareToast.visible)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString($setup.shareToast.message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
